import React, { useState, useEffect } from 'react';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import style from "../components/yourDestination.module.css";
import Place1 from "../assets/Frame 1618873446.png";
import Place2 from "../assets/Frame 1618873447.png";
import Place3 from "../assets/Frame 1618873448.png";
import Place4 from "../assets/Frame 1618873449.png";
import Place5 from "../assets/Frame 1618873449.png";
import Place6 from "../assets/Frame 1618873448.png";
import Place7 from "../assets/Frame 1618873447.png";
import Place8 from "../assets/Frame 1618873446.png";

import BASE_URL from '../config'; // Adjust the import path as necessary

const TopDestination = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [visibleCount, setVisibleCount] = useState(4);
    const [destinations, setDestinations] = useState([
        { id: 1, name: 'Dubai', image: Place1 },
        { id: 2, name: 'Singapore', image: Place2 },
        { id: 3, name: 'Australia', image: Place3 },
        { id: 4, name: 'Turkey', image: Place4 },
        { id: 5, name: 'India', image: Place5 },
        { id: 6, name: 'Maldives', image: Place6 },
        { id: 7, name: 'Thailand', image: Place7 },
        { id: 8, name: 'NewZeland', image: Place8 }
    ]);


    useEffect(() => {
        const fetchDestinations = async () => {
            try {
                const response = await fetch(`${BASE_URL}/api/tour/search/criteria?sort=popular&limit=10`);
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                
                const mapped = data && Array.isArray(data) ? data.map((item, idx) => ({
                    id: item.id || idx + 1,
                    name: item.name || item.title || `Destination ${idx + 1}`,
                    image: item.image || Place1 // fallback image if not present
                })) : [];
                setDestinations(mapped.length ? mapped : destinations);
            } catch (error) {
                setDestinations([
                    { id: 1, name: 'Dubai', image: Place1 },
                    { id: 2, name: 'Singapore', image: Place2 },
                    { id: 3, name: 'Australia', image: Place3 },
                    { id: 4, name: 'Turkey', image: Place4 },
                    { id: 5, name: 'India', image: Place5 },
                    { id: 6, name: 'Maldives', image: Place6 },
                    { id: 7, name: 'Thailand', image: Place7 },
                    { id: 8, name: 'NewZeland', image: Place8 }
                ]);
            }
        };
        fetchDestinations();
    }, []);

    // Responsive visible count
    useEffect(() => {
        const updateVisibleCount = () => {
            if (window.innerWidth < 600) {
                setVisibleCount(1);
            } else if (window.innerWidth < 900) {
                setVisibleCount(2);
            } else if (window.innerWidth < 1200) {
                setVisibleCount(3);
            } else {
                setVisibleCount(4);
            }
        };
        updateVisibleCount();
        window.addEventListener('resize', updateVisibleCount);
        return () => window.removeEventListener('resize', updateVisibleCount);
    }, []);

    const handleLeftClick = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? destinations.length - visibleCount : prevIndex - 1
        );
    };

    const handleRightClick = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex >= destinations.length - visibleCount ? 0 : prevIndex + 1
        );
    };

    const visibleDestinations = destinations.slice(
        currentIndex,
        currentIndex + visibleCount
    ).length === visibleCount
        ? destinations.slice(currentIndex, currentIndex + visibleCount)
        : [
            ...destinations.slice(currentIndex),
            ...destinations.slice(0, (currentIndex + visibleCount) % destinations.length)
        ];

    return (
        <>
            <div className='mb-5 ' style={{ marginTop: "10rem" }}>
                <div className="container mb-5 d-flex flex-row justify-content-between">
                    <div className="row">
                        <h3 style={{ color: "#321E5D", fontWeight: "800", }}>Top <span style={{ color: "#680099"}}>Destinations</span></h3>
                        <p className="" style={{ fontSize: "14px" }}>Ready For An International Adventure?</p>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="rounded-circle d-flex justify-content-center align-items-center bg-white" 
                            style={{ width: '40px', height: '40px', cursor: 'pointer', transition: 'transform 0.2s' }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            onClick={handleLeftClick}>
                            <MdArrowBackIos size={24} />
                        </div>
                        <div className="rounded-circle d-flex justify-content-center align-items-center bg-white" 
                            style={{ width: '40px', height: '40px', cursor: 'pointer', transition: 'transform 0.2s' }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            onClick={handleRightClick}>
                            <MdArrowForwardIos size={24} />
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="d-flex justify-content-center gap-4">
                        {visibleDestinations.map((place, idx) => (
                            <div key={place.id} className={`${style.card}`}>
                                <img src={place.image} alt={place.name} className={`${style.cardImage}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TopDestination;
